import { render } from "./App.vue?vue&type=template&id=eacb9ae8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=eacb9ae8&lang=css"

import exportComponent from "E:\\Work\\Tabnova SPA\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__